<template>
  <div class="add-con">
    <van-form @submit="onSubmit">
      <van-field required label="咨询类型">
        <template #input>
          <!-- 自定义样式label-flex -->
          <van-dropdown-menu active-color="#fff" :overlay="false" class id="rank">
            <van-dropdown-item v-model="value1" :options="option1" />
          </van-dropdown-menu>
        </template>
      </van-field>
      <van-field
        required
        v-model="value2"
        type="textarea"
        label="咨询内容"
        placeholder="咨询内容"
        autosize
        show-word-limit
        rows="4"
        maxlength="200"
      />
      <van-field name="uploader" label="上传图片">
        <template #input>
          <van-uploader
            :deletable="false"
            :max-size="10485760"
            @oversize="onOversize"
            :max-count="1"
            :after-read="afterRead"
            v-model="uploader"
          />
        </template>
      </van-field>
      <div class="addBut">
        <van-button
          :disabled='isDisabled'
          color="linear-gradient(to right, #ff6034, #ee0a24)"
          round
          block
          type="info"
          native-type="submit"
        >提交</van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import { Toast } from 'vant'
import URL from "@/api/api";
import URLTB from "@/api/apiTB";
export default {
  data() {
    return {
      value1: '0',//咨询类型
      value2: '',//咨询内容
      option1: [
        { text: '请选择', value: '0' },
        { text: '贷款业务', value: '3' },
        { text: '保险业务', value: '4' },
        { text: '操作使用', value: '5' },
        { text: '其他', value: '6' },
      ],
      uploader: [],
      cusImg: '',
      isDisabled:true,//提交按钮禁用
    }
  },
  mounted() {
  },
  methods: {
    onOversize(file) {
      Toast('文件大小不能超过 10MB');
    },
    afterRead(file) {//图片上传
      Toast.loading({
        duration: 300, // 持续展示 toast
        forbidClick: true,
        message: "上传中..."
      });
      let data = {
        file: file.file,
        bucketName: ''
      }
      this.$fetchPost(URL.uploadmessageImg.url, this.$toFormData(data)).then(res => {
        if (res.data.code == 20000) {
          this.cusImg = res.data.data.fileUrl
          Toast.clear();
          if(this.cusImg){
            this.isDisabled=false
          }
        }else{
          Toast('上传失败，请重新上传~')
        }
      })
    },
    onSubmit() {
      if (this.value1 == '') {
        Toast('请选择咨询类型')
      } else if (this.value2 == '') {
        Toast('请输入咨询内容')
      } else {
        let data = {
          userId: localStorage.getItem('userid'),
          dataType: this.value1,
          content: this.value2,
          cusImg: this.cusImg
        }
        this.$fetchPost(URLTB.addCommunication.url, data).then(res => {
          if (res.data.code == 20000) {
            Toast(res.data.msg)
            this.$router.go(-1)
          }
        })
      }

    }
  }
}
</script>

<style lang="less" scoped>
.add-con {
  height: 100vh;
  background: #ffffff;
  overflow: scroll;
  /deep/.van-dropdown-menu {
    width: 100%;
    .van-dropdown-menu__bar {
      height: auto;
      background-color: transparent;
      box-shadow: none;
      .van-dropdown-menu__title {
        width: 100%;
      }
    }
    .van-dropdown-item--down {
      width: 140px;
      left: 215px;
      .van-popup {
        background: #666666;
        .van-cell {
          font-size: 12px;
          background: #666666;
          color: #ffffff;
        }
        .van-cell::after {
          border: none;
        }
      }
    }
    .van-dropdown-item__option--active {
      background: #999999 !important;
    }
  }
  .addBut {
    width: 273px;
    margin: 220px auto 20px;
  }
}
</style>